import { useEffect, useRef, useState } from 'react';
import type { missions } from '../data/archive';

type Mission = (typeof missions)[number];

export function VideoModal({ mission, onClose }: { mission: Mission; onClose: () => void }) {
  const closeRef = useRef<HTMLButtonElement>(null);
  const [loaded, setLoaded] = useState(false);
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    const before = document.activeElement as HTMLElement | null;
    closeRef.current?.focus();
    const timer = window.setTimeout(() => setTimedOut(true), 9000);
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
      if (event.key === 'Tab') {
        const nodes = [...document.querySelectorAll<HTMLElement>('[data-modal] button, [data-modal] a, [data-modal] iframe')];
        const first = nodes[0]; const last = nodes[nodes.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.clearTimeout(timer); document.removeEventListener('keydown', onKey);
      document.body.style.overflow = ''; before?.focus();
    };
  }, [onClose]);

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <section className="video-modal" role="dialog" aria-modal="true" aria-labelledby="video-title" data-modal>
        <header>
          <div><span className="eyebrow">OFFICIAL TRAILER // MARVEL ENTERTAINMENT</span><h2 id="video-title">{mission.title}：{mission.subtitle}</h2></div>
          <button ref={closeRef} className="icon-button" onClick={onClose} aria-label="关闭预告片弹窗">×</button>
        </header>
        <div className={`video-frame ${loaded ? 'is-loaded' : ''}`}>
          <div className="video-fallback">
            <span>{mission.year}</span><strong>{mission.title}</strong>
            <p>{timedOut ? '视频服务可能受网络或隐私设置限制。' : '正在连接 Marvel Entertainment 官方视频…'}</p>
          </div>
          {!timedOut && <iframe
            src={`https://www.youtube-nocookie.com/embed/${mission.videoId}?autoplay=1&rel=0`}
            title={`${mission.title}官方预告片`} allow="autoplay; encrypted-media; picture-in-picture"
            allowFullScreen onLoad={() => setLoaded(true)}
          />}
        </div>
        <footer>
          <p>不托管电影片段。视频由 YouTube 隐私增强模式嵌入；若不可用，请使用官方链接。</p>
          <a className="text-link" href={mission.link} target="_blank" rel="noreferrer">在官方页面观看 <span>↗</span></a>
        </footer>
      </section>
    </div>
  );
}
